import React from "react";
import { TriangleAlert, X } from "lucide-react";
import { cancelRecordingMessage } from "../../globals";
import ModalPortal from "../../utils/ModalPortal";

const CancelRecordingConfirmModal = ({ isOpen, onCancel, onConfirm }) => (
  <ModalPortal isOpen={isOpen}>
    <div className="modal" onClick={onCancel}>
      <div
        aria-describedby="cancel-recording-description"
        aria-labelledby="cancel-recording-title"
        aria-modal="true"
        className="modal-content cancel-recording-modal"
        onClick={(event) => event.stopPropagation()}
        role="alertdialog"
      >
        <div className="cancel-recording-modal-heading">
          <TriangleAlert aria-hidden="true" size={26} />
          <h3 className="modal-title" id="cancel-recording-title">
            Cancel this recording?
          </h3>
        </div>
        <p className="cancel-recording-modal-description" id="cancel-recording-description">
          {cancelRecordingMessage}
        </p>
        <div className="modal-button-container cancel-recording-modal-actions">
          <button className="button-confirm" onClick={onCancel} type="button">
            Keep Recording
          </button>
          <button className="button-delete" onClick={onConfirm} type="button">
            <X aria-hidden="true" size={16} /> Cancel Recording
          </button>
        </div>
      </div>
    </div>
  </ModalPortal>
);

export default CancelRecordingConfirmModal;
